/* tslint:disable */
/* eslint-disable */
/**
 * mama health backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserExists
 */
export interface UserExists {
    /**
     * 
     * @type {boolean}
     * @memberof UserExists
     */
    userExists: boolean;
}

/**
 * Check if a given object implements the UserExists interface.
 */
export function instanceOfUserExists(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "userExists" in value;

    return isInstance;
}

export function UserExistsFromJSON(json: any): UserExists {
    return UserExistsFromJSONTyped(json, false);
}

export function UserExistsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserExists {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userExists': json['userExists'],
    };
}

export function UserExistsToJSON(value?: UserExists | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userExists': value.userExists,
    };
}

